query roles {
  roles {
    id
    slug
    name
    isDefault
    description
    permissions
    isAssignable
  }
}
